import React from 'react';
import { motion } from 'framer-motion';
interface SecondaryButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
export function SecondaryButton({
  children,
  onClick,
  disabled = false,
  className = '',
  icon
}: SecondaryButtonProps) {
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.97
  }} onClick={onClick} disabled={disabled} className={`w-full min-h-[48px] rounded-lg font-semibold text-base flex items-center justify-center gap-2 transition-colors border-2 ${disabled ? 'border-gray-200 text-gray-400 cursor-not-allowed' : 'border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900'} ${className}`} data-id="element-1882">
      {icon}
      {children}
    </motion.button>;
}